class ImageDeferrer {
  defer(element) {
    const url = element.getAttribute('data-src');

    const image = new Image();

    image.onload = () => {
      element.setAttribute('src', url);
      element.classList.add('loaded');
    };

    image.src = url;
  }
}

export default new ImageDeferrer();
